/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadAssignment } from './LeadAssignment';
import {
    LeadAssignmentFromJSON,
    LeadAssignmentFromJSONTyped,
    LeadAssignmentToJSON,
    LeadAssignmentToJSONTyped,
} from './LeadAssignment';

/**
 * 
 * @export
 * @interface CreateLeadAssignment200Response
 */
export interface CreateLeadAssignment200Response {
    /**
     * 
     */
    data: LeadAssignment;
}

/**
 * Check if a given object implements the CreateLeadAssignment200Response interface.
 */
export function instanceOfCreateLeadAssignment200Response(value: object): value is CreateLeadAssignment200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateLeadAssignment200ResponseFromJSON(json: any): CreateLeadAssignment200Response {
    return CreateLeadAssignment200ResponseFromJSONTyped(json, false);
}

export function CreateLeadAssignment200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadAssignment200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeadAssignmentFromJSON(json['data']),
    };
}

export function CreateLeadAssignment200ResponseToJSON(json: any): CreateLeadAssignment200Response {
    return CreateLeadAssignment200ResponseToJSONTyped(json, false);
}

export function CreateLeadAssignment200ResponseToJSONTyped(value?: CreateLeadAssignment200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadAssignmentToJSON(value['data']),
    };
}

